import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/work_logs/show_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchHarvestTeamWorkLogsTotal(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/work_logs/show_process/${organization_id}/fetch_harvest_team_work_logs_total/${harvest_process_id}`
    );
  },

  fetchHarvestTeamWorkLogs(organization_id, harvest_process_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `organization/process/work_logs/show_process/${organization_id}/fetch_harvest_team_work_logs/${harvest_process_id}/${current_page}/${rows_per_page}`
    );
  },
};
